import { ADD_AGENDA_ITEM } from '../actionTypes'

export const addAgendaItem = (data: object) => ({
  type: ADD_AGENDA_ITEM.name,
  api: {
    url: 'agenda_items/add',
    data,
  },
})
